"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDoiDSO = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _DomHelper = require("../../utils/DomHelper");
var _StringHelpers = _interopRequireDefault(require("../../utils/StringHelpers"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// const baseApiURLs = 'https://i-api.eon.de/cscn-customer-srv';
var data = (0, _DomHelper.getIdDataset)('cscn-config', 'props');
var cscConfig = data ? JSON.parse((0, _StringHelpers.default)((0, _DomHelper.getIdDataset)('cscn-config', 'props'))) : null;
var cicDomains = (0, _DomHelper.getIdDataset)('KUNDENPORTAL_MW_URL', 'cicMiddlewareDomains') || '{}';
var cscnCustomerDomain = (0, _DomHelper.getIdDataset)('KUNDENPORTAL_MW_URL', 'cscnMiddlewareCustomerDomain');
var cscnAccountDomain = (0, _DomHelper.getIdDataset)('KUNDENPORTAL_MW_URL', 'cscnMiddlewareAccountDomain');
var paramsString = window.location.search;
var searchParams = new URLSearchParams(paramsString);
// eslint-disable-next-line no-undef
var isA11yModeEnabled = __A11Y__ || (0, _DomHelper.getInputValueIfExists)('a11y-mode-enabled') === 'true';
var isDoiDSO = exports.isDoiDSO = function isDoiDSO(DSO) {
  return DSO;
};
var CONFIG = {
  GA_TRACKING_ID: 'XXXXXXXXX',
  GA_TRACKING_DEBUG: false,
  GA_ENABLED: false,
  ACTION_TYPES: {},
  CHANNEL_CONFIG: {
    anonymMR: 'ANONYMOUSMETERREADING',
    portal: 'PORTAL',
    loggedInCsc: 'CSC',
    postalAuth: 'ANONYMOUSINTERIMMETERREADING'
  },
  AEM_CONFIG: _objectSpread(_objectSpread({
    cscConfigAdded: !!cscConfig
  }, cscConfig), {}, {
    // TODO: move to AEM CONFIG.
    // LQA has only "service" as a path
    autologoutLandingPage: '/de/service/logout.html',
    offlineModeIsEnabled: (0, _DomHelper.getInputValueIfExists)('offline-portal-enabled-flag') === 'true',
    isDkePage: (0, _DomHelper.getInputValueIfExists)('dke-page') === 'true',
    isAuthorMode: (0, _DomHelper.getInputValueIfExists)('author_mode') !== null,
    isA11yModeEnabled: isA11yModeEnabled,
    a11yMockJwt: (0, _DomHelper.getInputValueIfExists)('a11y-mock-jwt'),
    a11yGuestToken: searchParams.get('guestToken'),
    middlewareDomains: _objectSpread(_objectSpread({}, JSON.parse(cicDomains)), {}, {
      cscnCustomerDomain: cscnCustomerDomain,
      cscnAccountDomain: cscnAccountDomain
    }),
    publicMode: searchParams.get('publicMode') === 'true' && isA11yModeEnabled,
    guestMode: isA11yModeEnabled && searchParams.get('guestToken')
  })
};
var _default = exports.default = CONFIG;